export const FIRST_NAME = 'Please enter your first name';
export const LAST_NAME = 'Please enter your last name';
export const EMAIL = 'Please enter your email address';
export const EMAIL_INVALID = 'Please enter a valid email address.';
export const COMPANY_NAME = 'account_setting.Please_enter_your_company_name';
export const PASSWORD = 'Please enter your password';
export const PASSWORD_DEFAULT = 'Password should be at least 8 characters';
export const EXISTED_EMAIL = 'Sorry, it seems like this email address is already registered';
export const PASSWORD_INVALID = 'Password should be at least 8 characters';
export const PASSWORD_NOT_MATCH = 'Password entered is not match';
export const SENT_EMAIL_SUCCESSFULLY = 'Password reset link was sent successfully.';
export const CHECK_INBOX_MESSAGE = 'Please check your inbox to reset password.';
export const RESET_PASS_SUCCESS = 'Your password has been reset successfully';
export const UN_CHECK_TERM = 'Please accept our Terms & Conditions';
export const CARD_NAME = 'account_setting.Please_enter_cardholder_name';
export const CARD_NUMBER = 'account_setting.Please_enter_your_card_number';
export const CARD_NUMBER_INVALID = 'account_setting.Card_number_entered_is_invalid';
export const CARD_EXPIRES = 'account_setting.Please_enter_the_expiry_date';
export const CARD_EXPIRES_INVALID = 'account_setting.Invalid_month_and_year';
export const CARD_CVC = 'account_setting.Please_enter_your_CVV_number';
export const CARD_INVALID_CVC = 'account_setting.Invalid_cvv';
export const VAT_BILLING_COUNTRY = 'account_setting.Please_select_your_billing_country';
export const PURCHASE_NOT_SUCCESSFUL = 'purchase.Unfortunately';
export const BILLING_ADDRESS = 'account_setting.Please_enter_your_billing_address';
export const BILLING_CITY = 'account_setting.Please_enter_the_city_of_your_billing_address';
export const STATE = 'account_setting.Please_enter_the_state_or_province_of_your_billing_address';
export const POST_CODE = 'account_setting.Please_enter_your_postcode';
export const INVALID_POSTCODE = 'account_setting.Invalid_postcode';
export const NOT_FIND_ACCOUNT = 'We cannot find any dashboard associated with the email entered.';
export const LOGIN_FAIL = 'Your account entered is incorrect.';
export const COUPON_EMPTY = 'purchase.Please_enter_coupon';
export const RESPONDENT_EMAIL_INVALID = 'Please provide a valid email address.';
export const RESPONDENT_INVITE_NO_MEMBER = 'Please add at least one team member to continue.';
export const RESPONDENT_ALREADY_EXISTS = 'This member is already part of this Attuned account.';
export const RESPONDENT_EMAIL_DUPLICATE = 'This email is duplicated.';
export const MISSING_SENDER_NAME = 'Please provide email sender\'s full name.';
export const MISSING_SENDER_EMAIL = 'Please provide the email address of the sender.';
export const MISSING_SENDER_SUBJECT = 'Please give this email a subject line.';
export const MISSING_TO_EMAIL = 'Please enter at least one email.';
export const TEAM_MEMBER_FIRST_NAME = 'Please provide the first name of the team member.';
export const TEAM_MEMBER_LAST_NAME = 'Please provide the last name of the team member.';
export const TEAM_MEMBER_EMAIL = 'Please provide the email address of the team member.';
export const NOT_ANSWER = 'purchase.Please_provide_an_answer';
